import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const LEQ_limit_enhance_API_CALL = createAsyncThunk(
  'LEQ_limit_enhance_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LEQ_limit_enhance_API_CALL/pending', payload: {} });
    const {
      limit_enhanceAPIPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { customerId, Authorization, customerRefNum } =
      limit_enhanceAPIPayload;
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      route: 'customerkyc/limit_enhance',
      payload: {
        customerRefNum,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const limit_enhanceRes = res;
        dispatch({
          type: 'LEQ_limit_enhance_API_CALL/fulfilled',
          payload: limit_enhanceRes,
        });
        if (successFn) successFn(limit_enhanceRes);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LEQ_limit_enhance_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const LEQ_limit_enhance_API_CALL_extrareducer = {
  [LEQ_limit_enhance_API_CALL.pending]: (state, action) => {
    state.limit_enhanceAPICall.isLoading = true;
  },
  [LEQ_limit_enhance_API_CALL.fulfilled]: (state, action) => {
    state.limit_enhanceAPICall.isLoading = false;
    state.limit_enhanceAPICall.isSuccess = true;
    state.limit_enhanceAPICall.isError = false;
    state.limit_enhanceAPICall.response = action.payload;
  },
  [LEQ_limit_enhance_API_CALL.rejected]: (state, action) => {
    state.limit_enhanceAPICall.isLoading = false;
    state.limit_enhanceAPICall.isSuccess = false;
    state.limit_enhanceAPICall.isError = true;
    state.limit_enhanceAPICall.response = action.payload;
  },
};
